import React from 'react'
import { StyleSheet, Text, View } from 'react-native';
import MyInput from './child';

export default function Parent() {
    const [value, setValue] = React.useState("");
  
    function handleChange(newValue) {
      setValue(newValue);
    }
  
    // We pass a callback to MyInput
    console.log(value);
    return <MyInput value={value} onChange={handleChange} />;
  }

const styles = StyleSheet.create({})
